import React, { useState, useEffect } from 'react';
import 'react-calendar/dist/Calendar.css';
import './Trainings.css';
import RegistrationForm from '../forms/RegistrationForm';
import { fetchTrainingsData, fetchMoreTrainings } from '../../utils/trainingService';
import TrainingRow from '../training/TrainingRow';

function Trainings() {
    const [trainings, setTrainings] = useState([]);
    const [expandedTraining, setExpandedTraining] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [selectedTraining, setSelectedTraining] = useState(null);
    const [loadingMore, setLoadingMore] = useState(false);

    useEffect(() => {
        fetchTrainingsData((data) => {
            const updatedTrainings = data.map(training => ({
                ...training,
                amount: 500
            }));
            setTrainings(updatedTrainings);
            setLoading(false);
        }, setLoading, setError);
    }, []);

    const toggleExpand = (trainingId) => {
        setExpandedTraining(expandedTraining === trainingId ? null : trainingId);
    };

    const openForm = (training) => {
        setSelectedTraining(training);
        setShowForm(true);
    };

    const closeForm = () => {
        setShowForm(false);
        setSelectedTraining(null);
    };

    const loadMoreTrainings = async () => {
        if (trainings.length === 0) return;

        setLoadingMore(true);

        // Get the last training's end date
        const lastTraining = trainings[trainings.length - 1];
        const lastDate = new Date(lastTraining.end.dateTime);

        // Add one day to get events after the last one
        lastDate.setDate(lastDate.getDate() + 1);
        const fromDate = lastDate.toISOString().split('T')[0];

        try {
            const moreTrainings = await fetchMoreTrainings(fromDate);

            // Take only the next 3 trainings
            const next3Trainings = moreTrainings.slice(0, 3).map(training => ({
                ...training,
                amount: 500
            }));

            setTrainings([...trainings, ...next3Trainings]);
        } catch (err) {
            console.error('Error loading more trainings:', err);
        } finally {
            setLoadingMore(false);
        }
    };

    return (
        <>
            <h2>Training Schedule</h2>
            {loading ? (
                <div className="loading-circle"></div>
            ) : error ? (
                <p>No trainings available.</p>
            ) : (
                trainings.map((training) => (
                    <TrainingRow
                        key={training.id}
                        training={training}
                        expandedTraining={expandedTraining}
                        toggleExpand={toggleExpand}
                        openForm={openForm}
                    />
                ))
            )}
            {!loading && !error && trainings.length > 0 && (
                <div className="load-more-container">
                    <button
                        className="load-more-button"
                        onClick={loadMoreTrainings}
                        disabled={loadingMore}
                    >
                        {loadingMore ? (
                            <div className="loading-circle-small"></div>
                        ) : (
                            <span className="arrow-down">▼</span>
                        )}
                    </button>
                </div>
            )}
            {showForm && <RegistrationForm closeForm={closeForm} training={selectedTraining} />}
        </>
    );
}

export default Trainings;
